import { getApi } from './api_instance'

export const myBids = async (
  {
    filterData,
    page,
    pageSize,
    bid_received,
    searchQuery,
    isCancelled,
    isBidPlaced
  },
  dispatch
) => {
  try {
    const url = bid_received ? 'bids?bid_received=true' : 'bids'
    if (isCancelled) {
      filterData = { ...filterData, isCancelled: true }
    }
    if (isBidPlaced) {
      filterData = { ...filterData, isCancelled: false }
    }
    filterData = JSON.stringify(filterData)
    const { data } = await getApi({
      apiUrl: `/projects/api/myBids/${url}${
        bid_received ? '' : '?'
      }&filterData=${filterData}&page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}`,
      sendToken: true,
      dispatch
    })
    return data
  } catch (error) {
    throw error
  }
}
